/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLpInspectionCouponDto } from '../../models/create-lp-inspection-coupon-dto';
import { LpInspectionCouponDto } from '../../models/lp-inspection-coupon-dto';

export interface LpInspectionCouponControllerCreate$Params {
      body: CreateLpInspectionCouponDto
}

export function lpInspectionCouponControllerCreate(http: HttpClient, rootUrl: string, params: LpInspectionCouponControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionCouponControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponDto>;
    })
  );
}

lpInspectionCouponControllerCreate.PATH = '/api/lp-inspection-coupon';
